import type { FC } from "react";
import styles from "./EmptyTickIcon.module.scss";

export const EmptyTickIcon: FC = () => {
  return (
    <svg className={styles.svg} fill="none">
      <circle cx="9" cy="9" r="7.5" fill="transparent" stroke="currentColor" />
    </svg>
  );
};
